'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SortableComposition = require('./SortableComposition');

Object.defineProperty(exports, 'sortable', {
  enumerable: true,
  get: function get() {
    return _SortableComposition.SortableComposition;
  }
});


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/react-sortable/lib/index.js
// module id = 1367
// module chunks = 0 3 5